function toggleFAQ(element) {
  var answer = element.nextElementSibling;
  var toggle = element.querySelector('.faq-toggle');

  // Close all other FAQs
  document.querySelectorAll('.faq-question').forEach(function (question) {
    if (question !== element) {
      question.classList.remove('active');
      question.nextElementSibling.classList.remove('active');
      question.querySelector('.faq-toggle').textContent = '+';
    }
  });

  // Toggle current FAQ
  element.classList.toggle('active');
  answer.classList.toggle('active');

  if (answer.classList.contains('active')) {
    toggle.textContent = '-';
  } else {
    toggle.textContent = '+';
  }
}